





























































































































import Vue from 'vue'
import SuggestedProgram from '@/components/search/SuggestedProgram.vue'
import Pill from '@/components/atoms/Pill.vue'
import SearchIcon from '@/assets/svgs/search_icon.svg?inline'
import { GET_NUM_CANDIDATES_WITH_MATCHING_SKILL_QUERY } from '@/graphql'

export default Vue.extend({
  name: 'Search',
  data: () => ({
    numCandidatesWithSuggestedSkillArray: [],
    suggestedPrograms: [
      {
        id: 1,
        name: 'Medical Assistant',
        numLearners: 362,
        skills: [
          'Anatomy and Physiology',
          'Customer Service',
          'EKG and Cardiovascular',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Administrative Assistant',
          'Medical Laws and Ethics',
          'Patient Care Coordination',
          'Pharmacology Basics'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '4',
            name: 'Learner 4',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/wow/fe80691561be99b9.png'
          },
          {
            id: '5',
            name: 'Learner 5',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/diego/716d92215b109690.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 2,
        name: 'Patient Care Technician',
        numLearners: 627,
        skills: [
          'Anatomy and Physiology',
          'Customer Service',
          'EKG and Cardiovascular',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Laws and Ethics',
          'Patient Care Coordination',
          'Phlebotomy'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '2',
            name: 'Learner 2',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/jon/8f3992ccc545b502.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 6,
        name: 'Home Health Aide',
        numLearners: 85,
        skills: [
          'Anatomy and Physiology',
          'Customer Service',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Laws and Ethics',
          'Patient Care Coordination'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '2',
            name: 'Learner 2',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/jon/8f3992ccc545b502.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '4',
            name: 'Learner 4',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/wow/fe80691561be99b9.png'
          },
          {
            id: '5',
            name: 'Learner 5',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/diego/716d92215b109690.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 7,
        name: 'Patient Care Coordinator',
        numLearners: 501,
        skills: [
          'Customer Service',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Administrative Assistant',
          'Medical Laws and Ethics',
          'Patient Care Coordination'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '2',
            name: 'Learner 2',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/jon/8f3992ccc545b502.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '4',
            name: 'Learner 4',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/wow/fe80691561be99b9.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 5,
        name: 'Caregiver',
        numLearners: 271,
        skills: [
          'Anatomy and Physiology',
          'Customer Service',
          'EKG and Cardiovascular',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Administrative Assistant',
          'Medical Laws and Ethics',
          'Patient Care Coordination',
          'Pharmacology Basics',
          'Phlebotomy'
        ],
        candidates: [
          {
            id: '2',
            name: 'Learner 2',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/jon/8f3992ccc545b502.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '5',
            name: 'Learner 5',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/diego/716d92215b109690.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 8,
        name: 'Hemodialysis Technician',
        numLearners: 123,
        skills: [
          'Anatomy and Physiology',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Laws and Ethics',
          'Patient Care Coordination',
          'Phlebotomy'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 4,
        name: 'Phlebotomy Technician',
        numLearners: 455,
        skills: [
          'Anatomy and Physiology',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Laws and Ethics',
          'Patient Care Coordination',
          'Phlebotomy'
        ],
        candidates: [
          {
            id: '1',
            name: 'Learner 1',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/boydell/7171dbda42865e49.png'
          },
          {
            id: '2',
            name: 'Learner 2',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/jon/8f3992ccc545b502.png'
          },
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '4',
            name: 'Learner 4',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/wow/fe80691561be99b9.png'
          },
          {
            id: '5',
            name: 'Learner 5',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/diego/716d92215b109690.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      },
      {
        id: 3,
        name: 'EKG Technician',
        numLearners: 84,
        skills: [
          'Anatomy and Physiology',
          'Customer Service',
          'EKG and Cardiovascular',
          'Electronic Medical Records',
          'Infection Control',
          'Medical Laws and Ethics',
          'Patient Care Coordination'
        ],
        candidates: [
          {
            id: '3',
            name: 'Learner 3',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/ryan1/75ac5dfe2a3434bb.png'
          },
          {
            id: '6',
            name: 'Learner 6',
            avatar: 'https://emoji.slack-edge.com/T244XQ6D8/weston/4ba23845324a65ed.png'
          }
        ]
      }
    ],
    suggestedSkills: [
      {
        id: 1,
        name: 'Healthcare Foundations'
      },
      {
        id: 2,
        name: 'Patient Care'
      },
      {
        id: 3,
        name: 'Infection Control'
      },
      {
        id: 4,
        name: 'Electronic Health Records'
      },
      {
        id: 5,
        name: 'Clinical Skills'
      },
      {
        id: 6,
        name: 'Testing & Lab Procedures'
      },
      {
        id: 7,
        name: 'Phlebotomy'
      },
      {
        id: 8,
        name: 'EKG & Cardiovascular Testing'
      },
      {
        id: 9,
        name: 'Healthcare Administration'
      },
      {
        id: 10,
        name: 'Care Coordination'
      },
      {
        id: 11,
        name: 'Basic Pharmacology'
      },
      {
        id: 12,
        name: 'Customer Service'
      }
    ]
  }),
  props: {
    cityOrZip: String
  },
  methods: {
    search (selectedProgramOrSkill: string, selectedType: string) {
      this.$emit('searchByProgramOrSkill', selectedProgramOrSkill, selectedType)
    },
    getNumCandidatesWithMatchingSkillSearch: function () {
      let skillNames = this.suggestedSkills.map((skill) => {
        return skill.name
      })
      this.$apollo.query({
        query: GET_NUM_CANDIDATES_WITH_MATCHING_SKILL_QUERY,
        variables: {
          location: this.cityOrZip,
          skillNames: skillNames
        }
      }).then((response) => {
        this.numCandidatesWithSuggestedSkillArray = response.data.getNumCandidatesWithMatchingSkill.numCandidatesWithMatchingSkill
      }).catch((error) => {
        console.log(error)
        this.numCandidatesWithSuggestedSkillArray = []
      })
    }
  },
  watch: {
    cityOrZip: function () {
      this.getNumCandidatesWithMatchingSkillSearch()
    }
  },
  components: {
    SuggestedProgram,
    Pill,
    SearchIcon
  },
  beforeMount: async function () {
    this.getNumCandidatesWithMatchingSkillSearch()
  }
})
